import { getNestingItemColors } from "#modules/layoutsV2/domain/getNestingItemColors";

const FORBIDDEN_ELEMENTS = "script, foreignObject";

const removeUnsafeContent = (root: Element) => {
  root.querySelectorAll(FORBIDDEN_ELEMENTS).forEach((element) => element.remove());
  [root, ...root.querySelectorAll("*")].forEach((element) => {
    [...element.attributes]
      .filter(({ name }) => name.toLowerCase().startsWith("on"))
      .forEach(({ name }) => element.removeAttribute(name));
  });
};

export const recolorNestingSvg = (svgText: string, itemIds: string[]): string | null => {
  const document = new DOMParser().parseFromString(svgText, "image/svg+xml");
  const root = document.documentElement;
  const isValidSvg =
    root.localName === "svg" && document.getElementsByTagName("parsererror").length === 0;
  if (!isValidSvg) {
    return null;
  }

  removeUnsafeContent(root);
  itemIds.forEach((itemId, index) => {
    const { background, text } = getNestingItemColors(index);
    root.querySelectorAll("[data-item-id]").forEach((element) => {
      if (element.getAttribute("data-item-id") !== itemId) {
        return;
      }
      element.setAttribute("fill", element.localName === "text" ? text : background);
    });
  });

  return new XMLSerializer().serializeToString(root);
};
